<template>
    <div class="grid">
        <div>
            <div class="card">
                <h4 class="card-header">Basic Information</h4>
                <div class="card-body">
                    <app-input
                        v-model="basicInfoForm.name"
                        placeholder="Name"
                        :error="basicInfoForm.errors.get('name')"
                        @updated="basicInfoForm.errors.clear('name')"
                        @keyup.enter.native="updateBasicInfo"
                    />
                    <app-input
                        v-model="basicInfoForm.username"
                        placeholder="Username"
                        :error="basicInfoForm.errors.get('username')"
                        @updated="basicInfoForm.errors.clear('username')"
                        @keyup.enter.native="updateBasicInfo"
                    />
                    <app-input
                        v-model="basicInfoForm.email"
                        placeholder="Email"
                        :error="basicInfoForm.errors.get('email')"
                        @updated="basicInfoForm.errors.clear('email')"
                        @keyup.enter.native="updateBasicInfo"
                    />
                    <app-select
                        v-model="basicInfoForm.timezone"
                        placeholder="Timezone"
                        :error="basicInfoForm.errors.get('timezone')"
                        @updated="basicInfoForm.errors.clear('timezone')"
                        :options="user.timezones"
                        value-key="id"
                        value-label="label"
                        required
                    />
                    <app-input
                        type="password"
                        v-model="basicInfoForm.password"
                        placeholder="Password"
                        help-text="For security purposes please enter your account password."
                        :error="basicInfoForm.errors.get('password')"
                        @updated="basicInfoForm.errors.clear('password')"
                        @keyup.enter.native="updateBasicInfo"
                    />                            
                    <div class="text-right mt-5">
                        <app-button 
                            class="btn btn-blue" 
                            :loading="basicInfoFormIsLoading"
                            :success.sync="basicInfoFormIsSuccess"
                            @click="updateBasicInfo"
                        >Update</app-button>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="card">
                <h4 class="card-header">Change Password</h4>
                <div class="card-body">
                    <app-input
                        type="password"
                        v-model="passwordForm.current"
                        placeholder="Current Password"
                        :error="passwordForm.errors.get('current')"
                        @updated="passwordForm.errors.clear('current')"
                        @keyup.enter.native="updatePassword"
                    />
                    <app-input
                        type="password"
                        v-model="passwordForm.new"
                        placeholder="New Password"
                        :error="passwordForm.errors.get('new')"
                        @updated="passwordForm.errors.clear('new')"
                        @keyup.enter.native="updatePassword"
                    />
                    <app-input
                        type="password"
                        v-model="passwordForm.new_confirmation"
                        placeholder="Confirm New Password"
                        @keyup.enter.native="updatePassword"
                    />
                    <div class="text-right mt-5">
                        <app-button 
                            class="btn btn-blue" 
                            :loading="passwordFormIsLoading"
                            :success.sync="passwordFormIsSuccess"
                            @click="updatePassword"
                        >Update</app-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import Form from '@/helpers/Form';
    export default {
        data() {
            return {
                basicInfoForm: new Form({
                    name: null,
                    username: null,
                    email: null,
                    password: null,
                    timezone: null,
                }),
                passwordForm: new Form({
                    current: null,
                    new: null,
                    new_confirmation: null,
                }),
                basicInfoFormIsLoading: false,
                basicInfoFormIsSuccess: false,
                passwordFormIsLoading: false,
                passwordFormIsSuccess: false,
            }
        },
        computed: {
            ...mapGetters({
                user: 'auth/user',
            })
        },
        mounted() {
            this.basicInfoForm.set(this.user);            
        },
        methods: {
            updateBasicInfo() {
                this.basicInfoFormIsLoading = true;
                this.$store.dispatch('account/updateProfile', this.basicInfoForm.payload())
                    .then(() => {
                        this.basicInfoFormIsLoading = false;
                        this.basicInfoFormIsSuccess = true;
                        this.basicInfoForm.set({password: null});
                    })
                    .catch(({ response }) => {
                        this.basicInfoFormIsLoading = false;
                        this.basicInfoForm.errors.record(response.data);
                    })
            },
            updatePassword() {
                this.passwordFormIsLoading = true;
                this.$store.dispatch('account/updatePassword', this.passwordForm.payload())
                    .then(() => {
                        this.passwordFormIsLoading = false;
                        this.passwordFormIsSuccess = true;
                        this.passwordForm.reset();
                    })
                    .catch(({ response }) => {
                        this.passwordFormIsLoading = false;
                        this.passwordForm.errors.record(response.data);
                    })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        grid-gap: theme('spacing.5');
    }
</style>